import { spaceRoutes } from '@/Space/space.routes';
const spaceModule = {
    routes: spaceRoutes
};
export default spaceModule;
